import styledComp from 'styled-components';

import { Styling, Colors } from '../../../../../constants';

export const ControlContainer = styledComp.div`
  padding-top: ${Styling.DEFAULT_SPACING}px;
`;

export const LabelContainer = styledComp.div`
  display: flex;
  justify-content: space-between;
`;

export const CharactersLeft = styledComp.span`
  color: ${Colors.BLACK_50};
`;

export const ControlLabel = styledComp.div`
  font-weight: bold;
  margin-bottom: ${Styling.DEFAULT_SPACING_HALVED}px;
`;
